// extracted by mini-css-extract-plugin
export default {"futureTitle":"Meetups-module--futureTitle--FYiSa"};